import { Map } from "./pages/Map";
import { StatusPage } from "./pages/StatusTable";
import { Route, Switch } from "react-router-dom";
import NotFound from "./pages/NotFound/NotFound";

export const DefaultRoutes = {
  MapPage: "/",
  StatusPage: "/status",
};

export const routes = (
  <Switch>
    <Route exact path={DefaultRoutes.StatusPage} component={StatusPage} />
    <Route exact path={DefaultRoutes.MapPage} component={Map} />
    <Route exact path="/Map" component={Map} />
    <Route component={NotFound} />
  </Switch>
);
